"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokensData = void 0;
const ton_png_1 = __importDefault(require("../assets/img/tokensMocked/ton.png"));
const dfc_png_1 = __importDefault(require("../assets/img/tokensMocked/dfc.png"));
const arbuz_png_1 = __importDefault(require("../assets/img/tokensMocked/arbuz.png"));
const kingy_png_1 = __importDefault(require("../assets/img/tokensMocked/kingy.png"));
const private_png_1 = __importDefault(require("../assets/img/tokensMocked/private.png"));
/* eslint-disable max-len */
exports.tokensData = [
    {
        token: 'TON',
        tokenLogo: ton_png_1.default,
        amount: '0',
        amountUSD: '0.00',
        tokenAddress: ['0:9a8da514d575d20234c3fb1395ee9138f5f1ad838abc905dc42c2389b46bd015', '0:436b4ff60f7bacf75f70d422cfb6b5ae7cd2846f0f3553ae8bcc798258923608']
    },
    {
        token: 'DFC',
        amount: '0',
        amountUSD: '0.00',
        tokenLogo: dfc_png_1.default,
        tokenAddress: ['0:f6eb371de82aa9cfb5b22ca547f31fdc0fa0fbb41ae89ba84a73272ff0bf2157', '0:c288b9102a934e1a93435f6a194470da340559a95e9c9816c682ccff2215149d']
    },
    {
        token: 'ARBUZ',
        amount: '0',
        amountUSD: '0.00',
        tokenLogo: arbuz_png_1.default,
        tokenAddress: ['0:0cd8a583a7d94dd18bf1bdf49b234af28c15f033bd2b6a4a4d2076ee1136ad45', '0:0cd8a583a7d94dd18bf1bdf49b234af28c15f033bd2b6a4a4d2076ee1136ad45']
    },
    {
        token: 'KINGY',
        amount: '0',
        amountUSD: '0.00',
        tokenLogo: kingy_png_1.default,
        tokenAddress: ['0:beb5d4638e860ccf7317296e298fde5b35982f4725b0676dc98b1de987b82ebc']
    },
    {
        token: 'PRIVATE',
        amount: '0.00',
        amountUSD: '0.00',
        tokenLogo: private_png_1.default,
        tokenAddress: ['0:37042dbb5cd7a29e5405bef4108a9304a132eea54b210244956f45b5dbd4c7fc']
    }
];
